import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Anchor,
  Button,
  Card,
  CardContent,
  Dialog,
  Type,
} from "@ebscois/react-component-library";
import { appendAmplitudeDeviceId } from "../../util/url-utils";
import ErrorBoundary from "../ErrorBoundary";
import { DlgActions } from "./PuaDialog.styled";

const PuaDialog = ({ puaDialog, linkURLs }) => {
  const [isOpen, setIsOpen] = useState(true);
  const dialogLabel = "pua-please-register";
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <ErrorBoundary team="cd.artfuldodgers">
      <Dialog
        background="black"
        data-testid={dialogLabel}
        id={dialogLabel}
        isOpen={isOpen}
        maxWidth="sm"
        onRequestClose={closeModal}
      >
        <Card>
          <CardContent>
            <Type element="p">
              {puaDialog.bestExperience}
              <Type element="span" fontWeight="semibold">
                {puaDialog.pleaseSignIn}
              </Type>
              <Type element="p" marginTop="md">
                <Type element="i">{puaDialog.justOnce}</Type>
              </Type>
            </Type>
          </CardContent>
        </Card>
        <DlgActions justifyActions="center">
          <Button
            kind="outlined"
            variant="primary"
            href={appendAmplitudeDeviceId(linkURLs.signInURL)}
            data-testid="pua-signin"
          >
            {puaDialog.signin}
          </Button>
          <Button
            kind="contained"
            variant="primary"
            style={{ marginLeft: ".5rem" }}
            href={appendAmplitudeDeviceId(linkURLs.registerURL)}
            data-testid="pua-register"
          >
            {puaDialog.createAcct}
          </Button>
        </DlgActions>
        <Card>
          <CardContent>
            <Anchor
              variant="primary"
              kind="anchor"
              onClick={closeModal}
              data-testid="pua-skip"
            >
              {puaDialog.noThanks}
            </Anchor>
          </CardContent>
        </Card>
      </Dialog>
    </ErrorBoundary>
  );
};

PuaDialog.propTypes = {
  puaDialog: {
    bestExperience: PropTypes.string,
    pleaseSignIn: PropTypes.string,
    justOnce: PropTypes.string,
    signin: PropTypes.string,
    createAcct: PropTypes.string,
    noThanks: PropTypes.string,
  },
  linkURLs: {
    registerURL: PropTypes.string,
    signInURL: PropTypes.string,
  },
};

PuaDialog.defaultProps = {
  puaDialog: {
    bestExperience:
      "For the best experience (including CME/CE and mobile app access), ",
    pleaseSignIn: "please sign in or create a personal user account.",
    justOnce: "You&apos;ll only need to do this once.",
    signin: "Sign In",
    createAcct: "Create Account",
    noThanks: "No thanks. Skip this step and remind me later.",
  },
  linkURLs: {
    registerURL: "/dha?action=register&returnToUrl=##returnToUrl##",
    signInURL: "/dha?returnToUrl=##returnToUrl##",
  },
};

PuaDialog.displayName = "PuaDialog";
export default PuaDialog;
